export const SLOT_EXPIRY_INITIAL = 'slot_expiry_initial';
export const SLOT_EXPIRY_FINAL = 'slot_expiry_final';
